import React from 'react';

import {
    Layout, Card, Button, Alert, Form, Row, Col, Input, Icon, Select
} from 'antd';

import '../App.css';
import Axios from 'axios';
import config from '.././config.json';
const { Header, Content, Footer, Sider } = Layout;

const keyvalue = 1;
const FormItem = Form.Item;
const Option = Select.Option;
const formItemLayout = {
    labelCol: {
        xs: { span: 3 },
        sm: { span: 3 },
    },
    wrapperCol: {
        xs: { span: 20 },
        sm: { span: 20 },
    },
};

class TcpView extends React.Component {

    handleSearch = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            console.log('Received values of form: ', values);
        });
    }

    handleReset = () => {
        this.props.form.resetFields();
    }

    render()
    {
        const { getFieldDecorator } = this.props.form;

        return (
            <div>
                <h1 style={{ textAlign: 'center' }} >Testing Certification Program</h1>
                    <Form onSubmit={this.handleSearch}>
                        <FormItem
                            {...formItemLayout}
                            label="Certification Type"
                        >
                            {getFieldDecorator(`certType`, { initialValue: '5year' })(
                                <Select style={{ width: 120 }} >
                                    <Option value="5year">5-Year</Option>
                                    <Option value="temp">Temp</Option>
                                </Select>
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label="Last Name"
                            hasFeedback
                        >
                            {getFieldDecorator(`lname`)(<Input placeholder="Last Name" style={{ width: '40%' }} />
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label="Employer"
                            hasFeedback
                        >
                            {getFieldDecorator(`employer`)(
                                <Input placeholder="Last Name" style={{ width: '40%' }} />
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="Technician ID #"
                        >
                            {getFieldDecorator(`techId`)(
                                <Input type="text" placeholder="Tech Id" style={{ width: '40%' }} />
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="Sort By"
                        >
                            {getFieldDecorator(`sort`, { initialValue: 'lnameSort' })(
                                <Select style={{ width: 120 }} >
                                    <Option value="lnameSort">Last Name</Option>
                                    <Option value="empSort">Employer</Option>
                                </Select>
                            )}
                        </FormItem>
                        <Row>
                            <Col span={48} style={{ textAlign: 'left' }}>

                            <button type="submit" className="btn btn-default">Submit</button>

                            </Col>
                        </Row>
                    </Form>
            </div>);
    }
 
}

const WrappedSearchForm = Form.create()(TcpView);
export default WrappedSearchForm;

//<Content>
//    <Button type="primary" style={{ backgroundColor: 'green', float: 'center' }} onClick={this.cardPdf.bind(this, keyvalue)}>Card Pdf</Button>
//</Content>
//cardPdf(keyvalue) {
//    Axios.post(config.serverUrl + '/pdfForm', { studentId: keyvalue }, { responseType: 'arraybuffer' }).then(
//        (response) => {
//            var binaryData = [];
//            binaryData.push(response.data);
//            var file = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
//            window.open(file);

//        });
//}



// WEBPACK FOOTER //
// ./src/CourseViews/Tcp.js